module.exports = __webpack_public_path__ + "img/ISO1.dce5e7a7.jpg";